module.exports = __webpack_public_path__ + "html/sales-analysis.component.html";